import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { refreshToken } from '../utils/Token';
import axios from 'axios';

const AdminProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [message, setMessage] = useState('');

    const token = sessionStorage.getItem('token');

    useEffect(() => {
        if (!token) {
            return <Navigate to="/login" />;
        }
        
        const fetcUserRole = async () => {
            try {
                const token = sessionStorage.getItem('token');
                const response = await axios.get('/api/checkRole', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const role = response.data.role;
                sessionStorage.setItem('role', role);
                if (role != 'admin') {
                    // remove token
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('role');

                    navigate('/login');
                }
            } catch (error) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('role');

                setMessage('Error checking user role');
                navigate('/login');
            }
        };

        fetcUserRole();

        const interval = setInterval(() => {
            refreshToken();
        }, 15 * 60 * 1000); // Refresh token every 15 minutes

        return () => clearInterval(interval);
    }, [navigate]);

    return children;
};

export default AdminProtectedRoute;